import { render, staticRenderFns } from "./PatientDetails2.vue?vue&type=template&id=67844a08&"
import script from "./PatientDetails2.vue?vue&type=script&lang=js&"
export * from "./PatientDetails2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports